import React from "react";
import { Grid, useTheme, useMediaQuery } from "@mui/material";
import ProjectCard from "../shared/projectsCertificatesCard";
import bankApp from "../../img/bankistApp.png";
import yogantaram from "../../img/yogantaram.png";
import myBus from "../../img/myBus.png";
import trivago from "../../img/trivago.png";
import expenseTracker from "../../img/expenseTrackerApp.png";
import guessGame from "../../img/guessGame.png";
import diceGame from "../../img/diceGame.png";
import ajaxCall from "../../img/ajaxApp.png";
import inputApp from "../../img/inputApp.png";
import reduxAuth from "../../img/reduxAuth.png";
import reduxBasedCounterApp from "../../img/reduxCounterApp.png";
import mobxBasedCounterApp from "../../img/mobxApp.png";

const AllProjectFetcher = () => {
  const themeHook = useTheme();
  const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));

  const projects = [
    {
      src: yogantaram,
      alt: "Yogantaram - WebApp for Yoga Therapist",
      link: "https://yogantaramv1.netlify.app/",
      techStack: [
        "ReactJs",
        "HTML",
        "CSS",
        "EmailJs",
        "SwipperJs",
        "React hooks",
        "Framer motion",
        "Material UI",
        "IconScout",
        "Media Query",
        "CSS module",
        "Firebase",
        "Router",
        "react count-up",
        "node.js",
        "express.js",
        "mongoose",
        "mongo DB",
        "Redux-Toolkit",
        "Postman"
      ],
    },
    {
      src: myBus,
      alt: "RedBus - Advance LLD",
      link: "https://advance-lld-redbus.netlify.app//",
      techStack: [
        "ReactJs",
        "HTML",
        "CSS",
        "React hooks",
        "React Router",
        "Redux Toolkit",
        "Material UI",
        "Javascript",
        "Browser storage",
        "React Toastify",
      ],
    },
    {
      src: trivago,
      alt: "Trivago - Advance LLD",
      link: "https://advanced-lld-trivago.netlify.app/",
      techStack: [
        "ReactJs",
        "HTML",
        "CSS",
        "React hooks",
        "Redux Toolkit",
        "Material UI",
        "Javascript"
      ],
    },
    {
      src: bankApp,
      alt: "Bankist App",
      link: "https://bankist-application-lr.netlify.app/",
      techStack: ['JavaScript', 'HTML', 'CSS'],
    },
    {
      src: expenseTracker,
      alt: "Expense Tracker",
      link: "https://expense-tracker-application-lr.netlify.app/",
      techStack: ['JavaScript', 'HTML', 'CSS'],
    },
    {
      src: guessGame,
      alt: "Guess Game",
      link: "https://guess-my-number-lr.netlify.app/",
      techStack: ['JavaScript', 'HTML', 'CSS'],
    },
    {
      src: diceGame,
      alt: "Dice Game",
      link: "https://dice-game-lr.netlify.app/",
      techStack: ['JavaScript', 'HTML', 'CSS'],
    },
    {
      src: ajaxCall,
      alt: "Ajax App",
      link: "https://ajax-call-lr.netlify.app/",
      techStack:['JavaScript', 'HTML', 'CSS'],
    },
    {
      src: reduxAuth,
      alt: "Redux Auth",
      link: "https://reduxjs-toolkit-counter-auth-lr.netlify.app/",
      techStack: ['Redux Toolkit', 'JavaScript', 'HTML', 'CSS'],
    },
    {
      src: reduxBasedCounterApp,
      alt: "Redux Toolkit Based Counter App",
      link: "https://ajax-call-lr.netlify.app/",
      techStack: ['Redux', 'JavaScript', 'HTML', 'CSS'],
    },
    {
      src: mobxBasedCounterApp,
      alt: "Mobx Based Counter App",
      link: "https://ajax-call-lr.netlify.app/",
      techStack: ['Mobx', 'JavaScript', 'HTML', 'CSS'],
    },
    {
      src: inputApp,
      alt: "Add User With Error Popup",
      link: "https://add-user-with-error-popup-lr.netlify.app/",
      techStack: ['JavaScript', 'HTML', 'CSS'],
    },
  ];

  return (
    <Grid
      container
      sx={{
        m: isSmallScreen ? 0 : 4,
        mb: isSmallScreen && 8,
        ml: !isSmallScreen && 7,
      }}
    >
      {projects.map((elem, index) => (
        <Grid item xs={12} md={4} key={index}>
          <ProjectCard
            image={elem.src}
            heading={elem.alt}
            link={elem.link}
            techStack={elem.techStack}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AllProjectFetcher;
